// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import initialRadioLookupFormValues from 'components/SearchAndSelect/Sets/Radio/initialFormValues'
import { initialize, setSubmitSucceeded } from 'redux-form'

// NOTE - in Path Database Lookup, we do not store the other antenna values.

const getInitialRadioLookupValues = (sourceForm, lookupFormName) => (dispatch, getState) => {
  const initialValues = { ...initialRadioLookupFormValues }

  let triggerSearchOnMount = false

  try {
    const { radioCode } = getState().form[sourceForm].values

    if (radioCode) {
      initialValues.radioCode = radioCode
      triggerSearchOnMount = true
    }
  } catch (e) {
    console.warn(`Warning: tried to initialize Radio Lookup for sourceForm ${sourceForm} however the sourceForm was not properly initialized.`)
    console.warn(e)
  }

  // if we want the lookup to auto search on mount, we need set some things up in redux
  if (triggerSearchOnMount) {
    dispatch(initialize(lookupFormName, initialValues))
    dispatch(setSubmitSucceeded(lookupFormName))
  }

  return {
    initialValues,
    triggerSearchOnMount,
  }
}

export default getInitialRadioLookupValues
